(function () {
  function loadStripeScript() {
    return new Promise(function (resolve, reject) {
      if (window.Stripe) {
        resolve(window.Stripe);
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://js.stripe.com/clover/stripe.js';
      script.async = true;
      script.onload = function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js failed to load.'));
        }
      };
      script.onerror = function () {
        reject(new Error('Stripe.js failed to load.'));
      };

      document.head.appendChild(script);
    });
  }

  function init() {
    var containers = document.querySelectorAll('.plm-messaging-container');
    if (!containers.length) return;

    containers.forEach(function (container) {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      var publishableKey = container.dataset.publishableKey;
      var initialAmount = parseInt(container.dataset.amount, 10);
      var currency = container.dataset.currency || 'USD';
      var countryCode = container.dataset.countryCode || 'US';
      var blockId = container.id.replace('plm-messaging-container-', '');

      if (!publishableKey || !Number.isFinite(initialAmount)) return;

      function getVariantData() {
        var scriptEl = document.getElementById('plm-variants-json-' + blockId);
        if (!scriptEl) return null;

        try {
          return JSON.parse(scriptEl.textContent || scriptEl.innerText || 'null');
        } catch (e) {
          return null;
        }
      }

      function findCurrentVariant(variants) {
        if (!Array.isArray(variants) || !variants.length) return null;

        var params = new URLSearchParams(window.location.search);
        var variantId = params.get('variant');

        if (!variantId) {
          var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
          if (idInput) variantId = idInput.value;
        }

        if (variantId) {
          var found = variants.find(function (v) { return String(v.id) === String(variantId); });
          if (found) return found;
        }

        var firstAvailable = variants.find(function (v) { return v.available; });
        if (firstAvailable) return firstAvailable;

        return variants[0];
      }

      function getCurrentAmount(variants, fallbackAmount) {
        if (variants && variants.length) {
          var currentVariant = findCurrentVariant(variants);
          if (currentVariant && typeof currentVariant.price === 'number') {
            return currentVariant.price;
          }
        }
        return fallbackAmount;
      }

      function setupVariantListeners(variants, updateAmount) {
        if (!variants || !variants.length) return;

        document.addEventListener('variant:change', function (event) {
          if (!event.detail || !event.detail.variant) return;
          if (typeof event.detail.variant.price !== 'number') return;
          updateAmount(event.detail.variant.price);
        });

        var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (idInput && typeof MutationObserver !== 'undefined') {
          var observer = new MutationObserver(function () {
            var amount = getCurrentAmount(variants, initialAmount);
            updateAmount(amount);
          });
          observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
        }

        var selectors = document.querySelectorAll('select[name="id"], input[name="id"]');
        selectors.forEach(function (el) {
          el.addEventListener('change', function () {
            setTimeout(function () {
              var amount = getCurrentAmount(variants, initialAmount);
              updateAmount(amount);
            }, 50);
          });
        });
      }

      var variants = getVariantData();
      loadStripeScript()
        .then(function (StripeConstructor) {
          var stripe = StripeConstructor(publishableKey);

          var elements = stripe.elements();

          var currentAmount = getCurrentAmount(variants, initialAmount);
          var options = {
            amount: currentAmount,
            currency: currency,
            paymentMethodTypes: ['klarna'],
            countryCode: countryCode
          };

          var paymentMessageElement = elements.create('paymentMethodMessaging', options);
          paymentMessageElement.mount(container);

          function updateStripeAmount(newAmount) {
            if (!Number.isFinite(newAmount) || newAmount <= 0) return;
            if (newAmount === currentAmount) return;

            currentAmount = newAmount;
            try {
              if (typeof paymentMessageElement.update === 'function') {
                paymentMessageElement.update({ amount: currentAmount });
              } else {
                paymentMessageElement.unmount();
                paymentMessageElement = elements.create('paymentMethodMessaging', {
                  amount: currentAmount,
                  currency: currency,
                  paymentMethodTypes: ['klarna'],
                  countryCode: countryCode
                });
                paymentMessageElement.mount(container);
              }
            } catch (e) {
            }
          }

          setupVariantListeners(variants, updateStripeAmount);
        })
        .catch(function () {
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
